import { LoginService } from './login.service';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ModalLoadingService } from './modal-loading.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  constructor(private router: Router, private loginService: LoginService, private modalLoading: ModalLoadingService) { }



  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let ignore = request.params.getAll('ignore') || [];
    let headers = {};
    request.headers.keys().forEach(k => headers[k] = request.headers.get(k));

    if(!ignore.includes('auth'))
      headers['authorization'] = this.loginService.getTokenLogin();
      
    if (!ignore.includes('loading')) 
      this.modalLoading.open();


    const authReq = request.clone({
      headers: new HttpHeaders(headers),
      params: request.params.delete('ignore'),
    });

    return next.handle(authReq).pipe(catchError(err => {

      if (!ignore.includes('401'))
        if (err.status === 401 && this.loginService.getTokenLogin != null) {
          this.loginService.logOut();
          this.router.navigate(['/login']);
        }
      return throwError(err);
    }), finalize(() => {
      if (!ignore.includes('loading')) this.modalLoading.close();
    }));

  }

}
